import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Card as MUICard,
  CardMedia,
  CardContent,
  Stack,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CustomButton from "./CustomButton";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules"
import "./Css/customSwiper.css";


function Card({ data }) {
  const navigate = useNavigate();
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRefs = useRef([]);
  const swiperRef = useRef(null);

  const handleVideoPlay = (index) => {
    setIsVideoPlaying(true);
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false);
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.start();
    }
  };

  const handleVideoEnd = () => {
    setIsVideoPlaying(false);
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.start();
    }
  };
  return (
    <MUICard
      sx={{
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        // p: 2,
        px: 2
      }}
    >

      <Stack mt={2} direction="row" spacing={2} alignItems="center">
        {(data?.photos?.length > 0 || data?.videos?.length > 0) && (
          <Box width="100%" position="relative">
            <Swiper
              modules={[Autoplay]}
              direction="horizontal"
              navigation={{
                nextEl: ".custom-swiper-button-next",
                prevEl: ".custom-swiper-button-prev",
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              allowTouchMove={!isVideoPlaying}
              pagination={false}
              spaceBetween={10}
              slidesPerView={1}
              style={{
                width: "100%",
                height: "200px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              {data.photos?.map((photo, index) => (
                <SwiperSlide key={`photo-${index}`}>
                  <img
                    src={photo}
                    alt={`Slide ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "fill",
                      borderRadius: "10px",
                    }}
                  />
                </SwiperSlide>
              ))}

              {data.videos?.map((video, index) => (
                <SwiperSlide key={`video-${index}`}>
                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    controls
                    onPlay={() => handleVideoPlay(index)}
                    onPause={handleVideoPause}
                    onEnded={handleVideoEnd}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  >
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        )}
      </Stack>

      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "space-between",
          // height: 250,
        }}
      >
        <Box>
          <Typography
            fontWeight="bold"
            gutterBottom
            color={theme.colors.text}
            fontSize="14px"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '300px',
            }}
          >
            {data?.name}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{ fontSize: "12px" }}
              color={theme.colors.text}
              fontWeight={500}
            >
              {data?.type}
            </Typography>
            <Box display="flex" alignItems="center">
              <Typography
                variant="body2"
                fontWeight="400"
                color={theme.colors.text}
                fontSize="12px"
              >
                {data?.averageRating}
              </Typography>
              <StarIcon
                sx={{ color: "#FFC107", fontSize: "12px", marginLeft: "4px" }}
              />
            </Box>
          </Stack>

          <Stack mt={1} spacing={1}>
            {data?.priceCategories?.[0] && (
              <Stack spacing={1}>
                {data?.priceCategories[0]?.price ? (
                  <Stack
                    direction="column"
                    justifyContent="space-between"
                  // alignItems="center"
                  >
                    {/* <Box display="flex" alignItems="center" gap={1}>
                      <AccessTimeIcon sx={{ color: theme.colors.text, fontSize: "20px" }} />
                      <Typography style={{ fontSize: "12px" }} color={theme.colors.text} fontWeight={400}>
                        {data?.duration} hours
                      </Typography>
                    </Box> */}
                    <Typography style={{ fontSize: "14px", display: 'flex', justifyContent: 'flex-end', marginTop: "10px" }} color={theme.colors.text} fontWeight="400">
                      <span style={{ fontWeight: "bold", textAlign: 'right' }}>
                        {data?.priceCategories[0]?.price?.convertedsymbol}

                        {data?.priceCategories[0]?.price?.convertsalePrice ? (
                          <>
                            {data?.priceCategories[0]?.price?.convertsalePrice}{" "}
                            <span style={{ textDecoration: "line-through" }}>
                              {data?.priceCategories[0]?.price?.convertedPrice}
                            </span>
                          </>
                        ) : (
                          data?.priceCategories[0]?.price?.convertedPrice
                        )}
                      </span>
                    </Typography>
                  </Stack>
                ) : (
                  data?.priceCategories[0]?.price?.[0] && (
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Box display="flex" alignItems="center" gap={1}>
                        <AccessTimeIcon sx={{ color: theme.colors.text, fontSize: "24px" }} />
                        <Typography variant="body2" color={theme.colors.text} fontWeight={400}>
                          {`${data?.duration} hours` || "No duration"}{" "}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color={theme.colors.text} fontWeight="400">
                        <span style={{ fontWeight: "bold" }}>
                          {data?.priceCategories[0]?.price[0]?.convertedsymbol}
                          {data?.priceCategories[0]?.price[0]?.convertedSalePrice ? (
                            <>
                              {data?.priceCategories[0]?.price[0]?.convertedSalePrice}{" "}
                              <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
                                {data?.priceCategories[0]?.price[0]?.convertedsymbol}{data?.priceCategories[0]?.price[0]?.convertedPrice}
                              </span>
                            </>
                          ) : (
                            data?.priceCategories[0]?.price[0]?.convertedPrice
                          )}
                        </span>
                      </Typography>
                    </Stack>
                  )
                )}
              </Stack>
            )}
          </Stack>


          {/* <Stack mt={1} spacing={1}>
            {data?.priceCategories?.map((category, index) => {
              return (
                <Stack key={index} spacing={1}>
                  {category?.price ? (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <AccessTimeIcon
                          sx={{ color: theme.colors.text, fontSize: "24px" }}
                        />
                        <Typography
                          variant="body2"
                          color={theme.colors.text}
                          fontWeight={400}
                        >
                          {data?.duration} hours
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        color={theme.colors.text}
                        fontWeight="400"
                      >
                        <span style={{ fontWeight: "bold" }}>
                          {category?.price?.convertedsymbol}
                          {category?.price?.convertsalePrice ? (
                            <>
                              {category?.price?.convertsalePrice}{" "}
                              <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
                                {category?.price?.convertedPrice}
                              </span>
                            </>
                          ) : (
                            category?.price?.convertedPrice
                          )}
                        </span>


                      </Typography>
                    </Stack>
                  ) : (
                    category?.prices?.map((priceItem, priceIndex) => (
                      <Stack
                        key={priceIndex}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <AccessTimeIcon
                            sx={{
                              color: theme.colors.text,
                              fontSize: "24px",
                            }}
                          />
                          <Typography
                            variant="body2"
                            color={theme.colors.text}
                            fontWeight={400}
                          >
                            {`${data?.duration} hours` || "No duration"}{" "}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          color={theme.colors.text}
                          fontWeight="400"
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {priceItem.convertedsymbol}
                            {priceItem.convertedSalePrice ? (
                              <>
                                {priceItem.convertedSalePrice}{" "}
                                <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
                                  {priceItem.convertedPrice}
                                </span>
                              </>
                            ) : (
                              priceItem.convertedPrice
                            )}
                          </span>

                        </Typography>
                      </Stack>
                    ))
                  )}
                </Stack>
              );
            })}
          </Stack> */}
        </Box>
        <CustomButton
          outline={true}
          fontSize="13px"
          onClick={() => {
            const formattedName = data?.name?.toLowerCase().replace(/\s+/g, "-");
           navigate(`/experience-detail/${formattedName}/${data?._id}`);
          }}

        >
          View Details
        </CustomButton>
      </CardContent>
    </MUICard>
  );
}

export default Card;
